const actions = {
  setSelectedPerson ({ commit }, person) {
    //- Mutate store
    commit('SET_SEL_PERSON', person)
  },
  updateSelectedPerson ({ commit }, person) {
    //- Mutate store
    commit('UPDATE_SEL_PERSON', person)
  }
}

export default actions
